import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import type { FilialFindInterface } from '@zaoblako/shared/modules/catalog/dtos/filial/filial-find.dto';
import type { ConverterFindInterface } from '@zaoblako/shared/modules/pacs/dtos/converter/converter-find.dto';
import type { UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import type { ClientFindInterface } from '@zaoblako/shared/modules/client/dtos/client/client-find.dto';

import * as yup from 'yup';

/** Room create/update request body */
export interface RoomFormInterface {
  /** Display name. */
  name: string;
  /** Room area in square meters */
  square?: number;
  /** Related filial */
  filial?: FilialFindInterface;
  /** Related client */
  client?: ClientFindInterface;
  /** Room entrance converters */
  converters?: ConverterFindInterface[];
  /** Related users who have access to the premises */
  allowUsers?: UserFindInterface[];
}

/** Room create/update request body - DTO schema */
export const RoomFormDto = SerdeDtoClass.create<RoomFormInterface>(CatalogDtosKeysEnum.ROOM_FORM_DTO, {
  name: {
    label: 'Название',
    serializer: yup
      .string()
      .min(1, DtoMessageEnum.EMPTY_STRING),
  },
  square: {
    optional: true,
    label: 'Площадь',
    serializer: yup
      .number()
      .min(0, DtoMessageEnum.NOT_ZERO_OR_POSITIVE),
  },
  filial: {
    optional: true,
    label: 'Филиал',
    serializer: yup.object({
      id: yup
        .number()
        .positive(DtoMessageEnum.NOT_POSITIVE)
        .integer(DtoMessageEnum.NOT_INTEGER),
    }) as yup.Schema<any>,
  },
  client: {
    optional: true,
    label: 'Клиент',
    serializer: yup.object({
      id: yup
        .number()
        .positive(DtoMessageEnum.NOT_POSITIVE)
        .integer(DtoMessageEnum.NOT_INTEGER),
    }) as yup.Schema<any>,
  },
  converters: {
    optional: true,
    label: 'Конвертеры',
    serializer: yup.array(yup.object({
      id: yup
        .number()
        .positive(DtoMessageEnum.NOT_POSITIVE)
        .integer(DtoMessageEnum.NOT_INTEGER),
    }) as yup.Schema<any>),
  },
    allowUsers: {
      optional: true,
      label: 'Пользователи, имеющие доступ к помещению',
      serializer: yup.array(yup.object({
        id: yup
          .number()
          .positive(DtoMessageEnum.NOT_POSITIVE)
          .integer(DtoMessageEnum.NOT_INTEGER),
      }) as yup.Schema<any>),
    },
});
